import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

const OPTIONS = [
  { value: 'all', label: 'All users' },
  { value: '6', label: 'Inactive 6+ months' },
  { value: '12', label: 'Inactive 12+ months' },
  { value: '24', label: 'Inactive 24+ months' },
];

const InactiveFilter = ({ value, onChange }) => (
  <Select value={value} onValueChange={onChange}>
    <SelectTrigger className="w-48" data-testid="inactive-filter">
      <SelectValue />
    </SelectTrigger>
    <SelectContent>
      {OPTIONS.map((o) => (
        <SelectItem key={o.value} value={o.value} data-testid={`inactive-filter-${o.value}`}>{o.label}</SelectItem>
      ))}
    </SelectContent>
  </Select>
);

export default InactiveFilter;
